/** Opções de formatação de valor monetário. */
export interface FormatMoneyOptions {
  /**
   * Quando `true`, prefixa `+` em valores positivos (negativos já trazem `-`).
   * Usado para deltas MoM/YoY (ex.: `+US$ 1.234,56`). Default: `false`.
   */
  signed?: boolean
}

/**
 * Formata valor em USD no estilo BR: `US$ 4.321,67`.
 *
 * - `null`/`undefined` retorna em-dash (`—`) — usado para sinalizar
 *   ausência de dado (não 0) em células de relatório.
 * - Sempre 2 casas decimais.
 * - `{ signed: true }` prefixa `+` em positivos (deltas MoM/YoY).
 */
export function formatMoney(
  v: number | null | undefined,
  opts: FormatMoneyOptions = {},
): string {
  if (v === null || v === undefined) return '—'
  const s = v.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
  const sign = opts.signed && v > 0 ? '+' : ''
  return `${sign}US$ ${s}`
}
